import { render } from "./DealsModal.vue?vue&type=template&id=125b6b17&ts=true"
import script from "./DealsModal.vue?vue&type=script&lang=ts"
export * from "./DealsModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__